import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Field, getIn } from 'formik';
import useTranslation from 'next-translate/useTranslation';

interface ICheckboxFieldProps {
  as?: any;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  label: string;
  name: string;
  value?: string;
  custom?: boolean;
  inline?: boolean;
  inputGroupPrepend?: any;
  shouldValidate?: boolean;
  defaultChecked?: boolean;
}

export const CheckboxField = ({ label, name, inline, custom, inputGroupPrepend, shouldValidate = true, ...rest }: ICheckboxFieldProps) => {
  const { t } = useTranslation('form-errors');

  return (
    <Field name={name}>
      {({ field, form }: { field: any; form: any }) => {
        const feedback = getIn(form.errors, field.name);
        const isTouched = getIn(form.touched, field.name);
        const isValid = shouldValidate && isTouched && !getIn(form.errors, field.name);
        const isInvalid = shouldValidate && !!feedback;
        const value = getIn(form.values, field.name);

        return (
          <Form.Group>
            <InputGroup>
              {inputGroupPrepend}
              <Form.Check
                {...field}
                {...rest}
                checked={!!value}
                isValid={isValid}
                isInvalid={isInvalid}
                type="checkbox"
                id={`${label}-${field.name}`}
                inline={inline}
                custom={custom}
                label={label}
                data-testid={field.name}
              />

              <Form.Control.Feedback type="invalid">{feedback && t(feedback)}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        );
      }}
    </Field>
  );
};
